<template>
  <div>
    <div class="d-flex flex-wrap gap-2 mb-2" v-if="modelValue.length">
      <span v-for="(id, index) in modelValue" :key="id" class="badge rounded-pill text-bg-primary d-inline-flex align-items-center gap-1 py-2 px-3">
        <button type="button" class="btn btn-link p-0 text-white" :disabled="index === 0" @click="move(index, -1)" title="Move left">
          <i class="bi bi-chevron-left small"></i>
        </button>
        {{ labelFor(id) }}
        <button type="button" class="btn btn-link p-0 text-white" @click="remove(id)" title="Remove">
          <i class="bi bi-x"></i>
        </button>
      </span>
    </div>
    <select class="form-select" :value="''" @change="add($event.target.value); $event.target.value = ''">
      <option value="">{{ placeholder }}</option>
      <option v-for="option in available" :key="option.id" :value="option.id">{{ option.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "OrderedMultiSelect",

  emits: ['update:modelValue'],

  props: {
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Add...' },
  },

  computed: {
    available() {
      return this.options.filter(o => !this.modelValue.includes(o.id))
    },
  },

  methods: {
    labelFor(id) {
      return this.options.find(o => o.id === id)?.name || 'Unknown'
    },
    add(id) {
      if (id && !this.modelValue.includes(id)) this.$emit('update:modelValue', [...this.modelValue, id])
    },
    remove(id) {
      this.$emit('update:modelValue', this.modelValue.filter(v => v !== id))
    },
    move(index, delta) {
      const list = [...this.modelValue]
      const [value] = list.splice(index, 1)
      list.splice(index + delta, 0, value)
      this.$emit('update:modelValue', list)
    },
  },
}
</script>
